export default "__VITE_ASSET__ca6289d2__"